import React, { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useOnboarding } from '../../contexts/OnboardingContext';
import { shouldHideUnifiedSpeedDial } from '../../utils/speedDialVisibility';

const SESSION_SEEN_KEY = 'apt_onboarding_session_seen';

export const FirstSessionTourTrigger: React.FC = () => {
  const location = useLocation();
  const triggeredRef = useRef(false);
  const {
    config,
    state,
    startTour,
    isFlowCompleted,
    getAvailableTours,
  } = useOnboarding();

  useEffect(() => {
    if (triggeredRef.current) return;
    if (!config.enabled || !config.autoStart) return;
    if (state.isRunning) return;
    if (location.pathname === '/') return;
    if (shouldHideUnifiedSpeedDial(location.pathname)) return;
    if (isFlowCompleted('welcome_quick_start')) return;
    if (localStorage.getItem(SESSION_SEEN_KEY) === '1') return;

    const available = getAvailableTours();
    const welcome = available.find((tour) => tour.id === 'welcome_quick_start');
    if (!welcome) return;

    triggeredRef.current = true;
    localStorage.setItem(SESSION_SEEN_KEY, '1');
    void startTour('welcome_quick_start');
  }, [
    config.autoStart,
    config.enabled,
    getAvailableTours,
    isFlowCompleted,
    location.pathname,
    startTour,
    state.isRunning,
  ]);

  return null;
};

export default FirstSessionTourTrigger;
